export const getUrlParamsStringFromArray = (urlParams: string[]): string => {
  if (!urlParams.length) {
    return '';
  }
  const urlParamsString = urlParams.join('&');
  return `?${urlParamsString}`;
};
